import _ from 'underscore';
import ko from 'knockout';

export default class ViewModel {
  constructor({
    i18n,
    defaultAdgroupId,
    defaultAdgroup,
    selectedAdgroupId,
  }) {
    this.i18n = i18n;
    this.totalCount = 0;
    this.defaultAdgroupId = defaultAdgroupId;
    this.defaultAdgroup = defaultAdgroup;
    this.suggestedAdgroupId = ko.observable(defaultAdgroupId || 0);
    this.selectedAdgroupId = ko.observable(selectedAdgroupId);
    this.adgroups = ko.observableArray([]);
    this.selectorControl = ko.observable();
    this.selectedAdgroup = ko.observable();
  }

  returnAdgroupIdInfoMapping(adgroupIdInfoMapping) {
    const { defaultAdgroupId, defaultAdgroup, i18n } = this;
    const defaultAdgroupProcessed = {
      id: `${defaultAdgroup.Id}`,
      name: `${i18n.getString(_TL_('(Recommended)'))} ${defaultAdgroup.name}`,
      status: defaultAdgroup.status,
    };
    if (!_.isEmpty(adgroupIdInfoMapping)) {
      if (!adgroupIdInfoMapping[defaultAdgroupId]) {
        // eslint-disable-next-line no-param-reassign
        adgroupIdInfoMapping[defaultAdgroupId] = defaultAdgroup;
      }
      this.adgroups = JSON.parse(JSON.stringify(adgroupIdInfoMapping));
      // eslint-disable-next-line no-param-reassign
      delete adgroupIdInfoMapping[defaultAdgroupId];
      const adgroupProcessed = _.chain(adgroupIdInfoMapping)
        .values()
        .sortBy('name')
        .map(adgroup => ({
          id: `${adgroup.Id}`,
          name: adgroup.name,
          status: adgroup.status,
        }))
        .value();
      adgroupProcessed.unshift(defaultAdgroupProcessed);
      return adgroupProcessed;
    }
    return [];
  }
}
